import script from "./EditInfoFormComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./EditInfoFormComponent.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__